import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../Contexts/AuthContext";
import ht from "../../Images/T_logo_rgb_n.svg";
import iskon from "../../Images/logo-iskon.svg";
import "../../Style/Login.css";
import { Link } from "react-router-dom";
import Footer from "../Common/Footer";
import { useTranslation } from "react-i18next";

const RecoverPassword = (props) => {
  const { t: translator } = useTranslation();
  const { changePassword, validationMsg, setValidationMsg } =
    useContext(AuthContext);

  useEffect(() => {
    document.body.id =
      window.REACT_APP_COLOR != "#eb7203" ? "login" : "login-iskon";
  }, []);

  const [password, setPassword] = useState({
    newPassword: "",
    confirmPassword: "",
  });
  const [pinType, setPinType] = useState("password");
  const params = new URLSearchParams(props.location.search);
  const token = params.get("token");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValidationMsg("");
    setPassword({ ...password, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!password) {
      setValidationMsg("Molimo unesite lozinku");
      return false;
    }
    changePassword(token, password.newPassword, password.confirmPassword)
      .then((res) => {
        if (res.status == 200) {
          setValidationMsg("Recover-Password-Success");
        } else {
          res.data.errors
            ? res.data.errors.forEach((error) => {
                setValidationMsg(translator(error.value));
              })
            : setValidationMsg(translator(res.data.message));
        }
      })

      .catch((err) => err);
  };

  return (
    <div>
      <nav className="navbar navbar-expand-lg brand-color p-0">
        <span className="navbar-brand pl-4">
          <img
            src={window.REACT_APP_VENDOR === "ht" ? ht : ht}
            alt="logo"
            id={`logo-login-${window.REACT_APP_VENDOR}`}
          />
        </span>
      </nav>
      <div
        className="col-lg-4"
        id={`login-box-${window.REACT_APP_VENDOR}`}
      >
        <h5 className="text-center text-uppercase teleServiceName">
          <strong>{translator("ForgotPassword-AndroidCashRegister")}</strong>
        </h5>
        <h1 className="text-center py-4 teleh1">
          {translator("ForgotPassword-RecoverPassword")}
        </h1>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              placeholder={translator("RecoverPassword-NewPassword")}
              type={pinType}
              className="form-control"
              name="newPassword"
              onChange={handleChange}
            />
            <span
              style={{ marginTop: "147px", marginRight: "45px" }}
              className="show-pin"
              onMouseDown={() => setPinType("text")}
              onMouseUp={() => setPinType("password")}
            >
              <i className="fas fa-eye text-dark"></i>
            </span>
          </div>
          <div className="form-group">
            <input
              placeholder={translator("RecoverPassword-ConfirmPassword")}
              type={pinType}
              className="form-control"
              name="confirmPassword"
              onChange={handleChange}
            />
            <span
              style={{ marginTop: "205px", marginRight: "45px" }}
              className="show-pin"
              onMouseDown={() => setPinType("text")}
              onMouseUp={() => setPinType("password")}
            >
              <i className="fas fa-eye text-dark"></i>
            </span>
          </div>
          <div className="text-center text-danger mb-2">
            <span>{translator(validationMsg)}</span>
          </div>
          <div style={{ marginBottom: "7px" }}>
            *{translator("RecoverPass-rule")}
          </div>
          <button type="submit" className="btn btn-primary w-100">
            {translator("Btn-Send")}
          </button>
        </form>
        <div className="mt-4">
          <Link to="/" className="teleLink">
            {translator("ForgotPassword-Home")}
          </Link>
          <a
            className="teleLink float-right"
            href="https://www.hrvatskitelekom.hr/poslovni/podrska-poslovni/ict"
            target="_blank"
          >
            {translator("ForgotPassword-Help")}
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default RecoverPassword;
